export const DEEMA_SCRIPT_URL = process.env.NEXT_PUBLIC_DEEMA_SCRIPT_URL
// Deema will only load on Stage & Production - false mean not configured
export const SHOULD_LOAD_DEEMA = !!DEEMA_SCRIPT_URL && DEEMA_SCRIPT_URL !== 'false'

export const DEEMA_STORAGE_KEYS = {
    activationTime: 'deema_activation_time',
    cartAddedTime: 'deema_cart_added_time',
}

export const DEEMA_DEADLINES = {
    addToCartDeadline: +(process.env.NEXT_PUBLIC_DEEMA_ADD_TO_CART_DEADLINE_HOURS || '24') * 60 * 60 * 1000, // 24 hours
    purchaseDeadline: +(process.env.NEXT_PUBLIC_DEEMA_PURCHASE_DEADLINE_HOURS || '360') * 60 * 60 * 1000, // 360 hours = 15 days
}
